import React from "react";
import { Platform } from "react-native";
const escapeHatches = [];
if (Platform.OS === "web") {
    window.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            const last = escapeHatches.pop();
            if (last != null) {
                last();
            }
        }
    });
}
export function useEnterPressed(escapeHatch) {
    if (Platform.OS === "web") {
        React.useEffect(() => {
            escapeHatches.push(escapeHatch);
            return () => {
                const index = escapeHatches.indexOf(escapeHatch);
                if (index > -1) {
                    escapeHatches.splice(index, 1);
                }
            };
        }, [escapeHatch]);
    }
}
